import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpClientModule } from '@angular/common/http';
import { HttpModule } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
import { environment } from '../../../environments/environment';
import { ForgotPasswordService } from '../../_services/forgot-password.service';

@Component({
	selector: 'app-reset-password',
	templateUrl: './reset-password.component.html',
	styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {

	changePswdForm : FormGroup;
	private url = environment.url;

	passwordMatch = false;

	constructor(private http : HttpClient, private router : Router, private forgotPasswordService: ForgotPasswordService) { }

	ngOnInit() {
		this.changePswdForm = new FormGroup ({
			"old_password" : new FormControl(null, Validators.required),
			"password" : new FormControl(null, Validators.required),
			"confirm_password" : new FormControl(null, Validators.required)
		});
	};

	submit(){
		this.forgotPasswordService.forgotPasswordReset(this.changePswdForm.value)
		.subscribe(resp =>{
			console.log(resp);
			if (resp['status'] === true) {
				// this.router.navigate(['/forgot-password/email-confirmation']);
				swal('Success', resp['message'], 'success').then(() => {
					localStorage.removeItem("currentUser");
				    this.router.navigate(['/login']);
				});
			} else {
				swal('Failure', resp['message'], 'error');
			}
		})
	};

	checkMatch(){

		console.log("inside check");
		if (this.changePswdForm.get("password").value == this.changePswdForm.get("confirm_password").value ){
			this.passwordMatch = true;
		}
		else{
			this.passwordMatch = false;
		}

	};

}



// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/forgot-password/reset-password/reset-password.component.ts